import { useMemo } from "react";

/**
 * Tactical bar-based waveform visualizer.
 * Purely CSS/keyframe-driven (no getUserMedia analyser needed for MVP).
 */
export function Waveform({ active, color = "#FFD700", bars = 32 }) {
  const arr = useMemo(() => Array.from({ length: bars }), [bars]);
  return (
    <div className="flex items-center justify-center gap-[3px] h-16 select-none" data-testid="waveform">
      {arr.map((_, i) => {
        const delay = (i * 0.07).toFixed(2);
        const baseHeight = 20 + ((i * 7) % 40);
        return (
          <span
            key={i}
            className={`w-[3px] rounded-sm ${active ? "tw-wave-bar" : ""}`}
            style={{
              height: `${baseHeight}%`,
              backgroundColor: active ? color : "#262626",
              animationDelay: active ? `${delay}s` : undefined,
            }}
          />
        );
      })}
    </div>
  );
}
